module.exports = __webpack_public_path__ + "img/queropago.1c5e0a44.svg";